// Autogenerated file
export const syncEntityTypesEnum = {
    Bid: "Bid",
    DistributionBid: "DistributionBid",
};
export const syncEntityTypes = [
    { label: "Заявка", value: "Bid" },
    { label: "Заказ", value: "DistributionBid" },
];
